import styled from 'styled-components'
import {
	space,
	flexbox,
	grid,
	height,
	margin,
	border,
	position,
	type GridProps,
	type SpaceProps,
	type HeightProps,
	type MarginProps,
	type FlexboxProps,
	type PositionProps,
	type BorderProps,
} from 'styled-system'

type BoxProps = SpaceProps &
	MarginProps &
	HeightProps &
	PositionProps &
	BorderProps

export const Box = styled.div<BoxProps>`
	${space}
	${margin}
	${height}
	${position}
	${border}
`

export const Flex = styled(Box)<
	FlexboxProps & BoxProps & { gap?: number | string }
>`
	display: flex;
	${({ gap }) =>
		gap ? `gap: ${typeof gap === 'number' ? `${gap}px` : gap};` : undefined}
	${flexbox}
`

export const Grid = styled(Box)<
	GridProps & BoxProps & { gap?: number | string; alignItems?: string }
>`
	display: grid;
	${({ gap }) =>
		gap ? `gap: ${typeof gap === 'number' ? `${gap}px` : gap};` : undefined}
	${({ alignItems }) =>
		alignItems ? `align-items: ${alignItems};` : undefined}

	${grid}
`
